import { isValidArray, isValidObject } from "./globalHelper";

/**
 * Set local storage
 *
 * @param {string} key - Key for the storage
 * @param {any} data - Data to be stored
 * @returns void
 */
export const setLocalStorage = (key, data) => {
  if (typeof window !== "undefined") {
    if (isValidArray(data) || isValidObject(data)) {
      data = JSON.stringify(data);
    }
    if (typeof data === "string") {
      localStorage.setItem(key, data);
    }
  }
};

/**
 * Get data from local storage
 *
 * @param {string} key - Key for the storage
 * @param {boolean} needParsedData - Whether to parse the data or not
 * @returns any
 */
export const getLocalStorage = (key, needParsedData) => {
  if (typeof window !== "undefined") {
    const data = localStorage.getItem(key);
    if (!data || typeof data === "undefined") return null;
    if (needParsedData) return JSON.parse(data);
    return data;
  }
};

/**
 * Get a specific key from local storage
 *
 * @param {string} storageKey - Key for the storage
 * @param {string} requiredKey - Required key
 * @returns any
 */
export const getKeyFromStorage = (storageKey, requiredKey) => {
  const data = getLocalStorage(storageKey, true);
  return data?.[requiredKey] || null;
};

/**
 * Remove data from local storage
 *
 * @param {string} storageKey - Key for the storage
 * @returns void
 */
export const removeFromLocalStorage = (storageKey) => {
  if (typeof window !== "undefined") {
    localStorage.removeItem(storageKey);
  }
};
